import React from 'react';
import PropTypes from 'prop-types';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'src/components/ui/select';

// A tab can merge more than one underlying candidate status — e.g.
// "Contacted" also covers "Acknowledged" (see AssignmentPipeline.jsx's
// currentStatusFilters, driven by the active status's own `filters.status`
// array from GET .../flow-statuses). By default all of them are fetched
// together; this lets the user narrow that down to just one specific
// underlying status. Only rendered by the caller when the active tab
// actually has more than one to narrow between — a single-status tab has
// nothing for this control to do.
const SubStatusFilter = ({ statuses, value, onChange }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="w-44 h-10 text-sm rounded-lg bg-card text-foreground-strong border-input shrink-0">
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value="all">All statuses</SelectItem>
      {statuses.map((status) => (
        <SelectItem key={status} value={status}>
          {status}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

SubStatusFilter.propTypes = {
  statuses: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

SubStatusFilter.defaultProps = {
  value: 'all',
  onChange: () => {},
};

export default SubStatusFilter;
